import type { SkillTemplate } from '@seen/core/models/skillTemplate'
import { Button } from '@seen/ui'
import { SkillList } from '@seen/ui/ai-elements'
import { IconDots } from '@tabler/icons-react'
import type { JSX } from 'react'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuDeleteItem,
  DropdownMenuTrigger,
} from '#src/components/core/dropdown-menu/index.ts'
import { HoverDate } from '#src/components/core/hover-card/HoverDate.tsx'
import { HoverPractitioner } from '#src/components/core/hover-card/HoverPractitioner.tsx'

export interface SkillsListProps {
  skills: SkillTemplate[]
  emptyLabel?: string
  className?: string
  onSkillClick?: (skill: SkillTemplate) => void
  onDeleteSkill?: (skill: SkillTemplate) => void
}

export function SkillsList({
  skills,
  emptyLabel,
  className,
  onSkillClick,
  onDeleteSkill,
}: SkillsListProps): JSX.Element {
  return (
    <SkillList<SkillTemplate>
      skills={skills}
      emptyLabel={emptyLabel}
      className={className}
      onSkillClick={onSkillClick}
      renderUpdatedAt={(skill) =>
        skill.lastUpdated ? <HoverDate date={skill.lastUpdated} /> : null
      }
      renderOwner={(skill) => {
        const author = skill.lastUpdatedByPractitioner
        return author ? (
          <HoverPractitioner practitioner={author} />
        ) : (
          <span className="text-muted-foreground">--</span>
        )
      }}
      renderActions={(skill) =>
        onDeleteSkill ? (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button
                type="button"
                variant="ghost"
                size="icon-sm"
                className="-my-2"
                onClick={(event) => event.stopPropagation()}
              >
                <IconDots className="size-4" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent
              align="end"
              onClick={(event) => event.stopPropagation()}
            >
              <DropdownMenuDeleteItem
                deleteConfirmationProps={{
                  title: `Delete "${skill.title || 'Untitled skill'}"?`,
                  description:
                    'Deleted skills can still be recovered by contacting our team.',
                  onConfirm: () => onDeleteSkill(skill),
                }}
              />
            </DropdownMenuContent>
          </DropdownMenu>
        ) : null
      }
    />
  )
}
